import { observer } from "mobx-react";
import React from "react";
import { Grid } from "@mui/material";
import { Suggestion } from "../Suggestions/Suggestion";
import { useCurrentChatStore } from "components/KBo/Stores/useCurrentChat";

export const SelectAllModulesInCategoryAction = observer(({ args }) => {
    const currentChatStore = useCurrentChatStore();
    const message = `Give me all modules in category ${args}`;

    return (
        <Grid item>
            <Suggestion
                onClick={() => {
                    currentChatStore?.streamingSubmitInput({
                        userMessage: message,
                        manualInput: "The chosen category is: Category_" + args,
                    });
                }}
            >
                {message}
            </Suggestion>
        </Grid>
    );
});
